import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import React from 'react';
import { processLink } from '../../shared/processLink';
import { ReachButton } from '../ReachButton/ReachButton';
import { ParentNodeProvider } from '../../providers/ParentNodeProvider';
import { AccentedText } from '../AccentedText/AccentedText';

export interface TwoColumnCardColumnProps {
    heading?: string;
    eyebrow?: string;
    text?: string;
    links?: [
        {
            title: string;
            uri: string;
        }
    ];
    image?: IGatsbyImageData;
    imageAlt?: string;
}

export const TwoColumnCardColumn = (props: TwoColumnCardColumnProps) => {
    return (
        <ParentNodeProvider nodeName={props.heading} nodeType="Two_Column">
            <div className="column">
                {props.image && (
                    <GatsbyImage
                        image={props.image}
                        alt={props.imageAlt ?? ``}
                    />
                )}
                {(props.heading || props.eyebrow) && (
                    <h3 className="typestack-title-4">
                        {props.eyebrow && (
                            <span className="eyebrow">{props.eyebrow}</span>
                        )}
                        {props.heading && <span>{props.heading}</span>}
                    </h3>
                )}
                {props.text && (
                    <div
                        className="text"
                        dangerouslySetInnerHTML={{
                            __html: props.text,
                        }}
                    ></div>
                )}
                {props.links?.length > 0 && (
                    <div className="buttons">
                        {props.links.map((link, idx) => (
                            <ReachButton
                                href={processLink(link.uri)}
                                buttonStyle="borderless"
                                buttonIcon={{
                                    icon: `ki-arrow-right`,
                                    position: `right`,
                                }}
                                key={idx}
                            >
                                {link.title}
                            </ReachButton>
                        ))}
                    </div>
                )}
            </div>
        </ParentNodeProvider>
    );
};
